<template>
<div>
    <div class="w-full bg-grey-400">
        <div
            class="text-xs leading-none pb-1 text-center text-white"
            :style="{
                background: `${color}`,
                width: `${strengthPercentage}%`,
            }"
        ></div>
    </div>
    <small v-if="isCommon" :class="errorTextClass">
        This is a very common password.
    </small>
</div>
</template>

<script>
import hibp from './hibp';
import strength from './strength';

export default {
    props: {
        password: {
            type: String,
            required: true,
        },

        startHue: {
            type: Number,
            required: false,
            validator: value => value >= 0 && value <= 360,
            default: () => window.passwordStrength ? window.passwordStrength.startHue : 0,
        },

        finishHue: {
            type: Number,
            required: false,
            validator: value => value >= 0 && value <= 360,
            default: () => window.passwordStrength ? window.passwordStrength.finishHue : 110,
        },

        saturation: {
            type: Number,
            required: false,
            validator: value => value >= 0 && value <= 1,
            default: () => window.passwordStrength ? window.passwordStrength.saturation : 0.75,
        },

        lightness: {
            type: Number,
            required: false,
            validator: value => value >= 0 && value <= 1,
            default: () => window.passwordStrength ? window.passwordStrength.lightness : 0.5,
        },

        errorTextClass: {
            type: String,
            required: false,
            default: () => window.passwordStrength ? window.passwordStrength.errorTextClass : 'text-red',
        }
    },

    data: function () {
        return {
            isCommon: false,
        };
    },

    computed: {
        strengthPercentage: function () {
            return (strength(this.password).score / 100) * 100;
        },

        strengthDescription: function () {
            return strength(this.password).description;
        },

        color: function () {
            let hue = ((this.finishHue - this.startHue) * (this.strengthPercentage / 100)) + this.startHue;

            return `hsl(${hue}, ${this.saturation * 100}%, ${this.lightness * 100}%)`;
        },
    },

    mounted: function () {
        window.bus.$on('hibp', occurances => {
            this.isCommon = occurances > 1000;
        });
    },

    watch: {
        password: function (password) {
            if (password.length >= 6) {
                hibp(password);
            } else {
                this.isCommon = false;
            }
        },
    },
}
</script>
